import * as React from 'react'
import classNames from 'classnames'
import { Button } from 'antd'
import config from './typeConfig'

import './exception.scss'

interface Props {
  className?: string
  backText?: string
  linkElement?:
    | React.FunctionComponent<any> // eslint-disable-line @typescript-eslint/no-explicit-any
    | React.ComponentClass<any> // eslint-disable-line @typescript-eslint/no-explicit-any
    | string
  type?: '403' | '404' | '500'
  title?: string
  desc?: string
  img?: string
  actions?: React.ReactNode
  redirect?: string
  style?: React.CSSProperties
}

const Exception = ({
  backText = 'back to home',
  redirect = '/',
  className = '',
  linkElement = 'a',
  type = '404',
  title = '',
  desc = '',
  img = '',
  actions = null,
  ...rest
}: Props): JSX.Element => {
  const pageType = type in config ? type : '404'
  const clsString = classNames('exception--container', className)
  const style = {
    backgroundImage: `url(${img || config[pageType].img})`,
  }

  return (
    <div className={clsString} {...rest}>
      <div className="exception--img-block">
        <div className="exception--img-ele" style={style} />
      </div>
      <div className="exception--content">
        <h1>{title || config[pageType].title}</h1>
        <div className="exception--desc">{desc || config[pageType].desc}</div>
        <div className="exception--actions">
          {actions ||
            React.createElement(
              linkElement,
              {
                to: redirect,
                href: redirect,
              },
              <Button type="primary">{backText}</Button>
            )}
        </div>
      </div>
    </div>
  )
}

export default Exception
